<script setup>
import NotificationGrid from '@/components/NotificationGrid.vue'
</script>
<template>
  <notification-grid />
</template>
